import { render } from "./MatchPredictions.vue?vue&type=template&id=15f11a6c&scoped=true"
import script from "./MatchPredictions.vue?vue&type=script&lang=js"
export * from "./MatchPredictions.vue?vue&type=script&lang=js"

import "./MatchPredictions.vue?vue&type=style&index=0&id=15f11a6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f11a6c"]])

export default __exports__